import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Shoaib Jamil </span>
            from <span className="purple"> Lahore, Pakistan.</span>
            <br /> A passionate MERN stack developer with two years of hands-on experience in crafting dynamic and responsive web applications. My journey in the world of coding began with a fascination for building seamless user experiences and has evolved into a dedicated pursuit of excellence in full-stack development.
            <br />
            Additionally, I am 
            <br />
            <br />
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Proficient in MongoDB, Express.js, React.js, and Node.js, I thrive on transforming ideas into robust, scalable solutions. Whether it's architecting the backend infrastructure or fine-tuning the frontend UI, I'm committed to delivering high-quality, performance-driven applications that exceed expectations.
            </li>
            <br />
            <br />
            <li className="about-activity">
              <ImPointRight /> With a keen eye for detail and a knack for problem-solving, I relish the challenges of turning complex concepts into elegant, user-friendly interfaces. Collaborative by nature, I thrive in team environments where innovation and creativity flourish, and I'm always eager to learn from and contribute to diverse projects.
            </li>
          </ul>
          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
